import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=2ec078b3&"
import script from "./VersionModal.ts?vue&type=script&lang=ts&"
export * from "./VersionModal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports